import React from 'react'

export default function Right() {

    return (
        <svg width="18" height="32" viewBox="0 0 18 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M0.71892 0.739941C1.67748 -0.246647 3.23161 -0.246647 4.19017 0.739941L17.2811 14.2136C18.2396 15.2002 18.2396 16.7998 17.2811 17.7864L4.19017 31.2601C3.23161 32.2466 1.67748 32.2466 0.71892 31.2601C-0.23964 30.2735 -0.23964 28.6739 0.71892 27.6873L12.0742 16L0.71892 4.31269C-0.23964 3.3261 -0.23964 1.72653 0.71892 0.739941Z" fill="black" />
        </svg>
    )
}
